import { createSignal } from '@verclam/pulsar';

/** `null` closes the panel; a template id opens it, listing that template's version history. */
const documentTemplateHistorySidebarSignal = createSignal<number | null>(null);

export const openDocumentTemplateHistorySidebar = (templateId: number): void => {
	documentTemplateHistorySidebarSignal.value = templateId;
};

export const closeDocumentTemplateHistorySidebar = (): void => {
	documentTemplateHistorySidebarSignal.value = null;
};

export default documentTemplateHistorySidebarSignal;
